<template>
  <div class="rating">
    <dotcom-icon
      v-for="count of [1, 2, 3, 4, 5]"
      :key="count"
      class="rating__icon"
      :class="{ ['rating__icon--active']: count <= value }"
      art="solid"
      name="star"
    />
  </div>
</template>

<script>
export default {
  name: 'DotcomRating',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },
  props: {
    value: {
      type: Number,
      default: 5,
    },
  },
}
</script>

<style scoped lang="postcss">
.rating {
  display: inline-flex;
  gap: var(--spacing-1);
}

.rating__icon {
  color: var(--c-primary-neutral-3);
  width: 15px;
  height: 15px;

  .container-wrapper.warm-gray &,
  .container-wrapper.sanitas-green &,
  .container-wrapper.sanitas-dark-green & {
    color: var(--c-primary-neutral-2);
  }
}

.rating__icon--active,
.rating__icon--active:hover,
.container-wrapper.warm-gray .rating__icon--active,
.container-wrapper.sanitas-green .rating__icon--active,
.container-wrapper.sanitas-dark-green .rating__icon--active {
  color: var(--c-primary-color-2);
}
</style>
